import React, { FC, ReactElement } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Button, { ButtonProps } from '@mui/material/Button';
import { clsx } from 'clsx';
import Text from '../text';

interface TextButtonProps extends ButtonProps {
    title: string;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    iconElement?: JSX.Element;
    customColor?: 'black' | 'grey' | 'lightblue';
}

const UnderlineTextButton: FC<TextButtonProps> = (props): ReactElement => {
    const { title, onClick, iconElement, customColor = 'black', className, ...rest } = props;
    const classes = useStyles();

    return (
        <Button
            onClick={onClick}
            startIcon={iconElement || undefined}
            className={clsx(classes.underlineTextButtonButton, classes[customColor], className)}
            {...rest}
        >
            <Text.Description14 text={title} customColor={customColor} />
        </Button>
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        underlineTextButtonButton: {
            textDecoration: 'underline',
            '& svg': {
                width: 14,
                height: 14,
            },
            '&:hover': {
                backgroundColor: 'transparent',
                // color: theme.palette.colors.background.focusElement,
                '& p': {
                    textDecoration: 'underline',
                    // color: theme.palette.colors.background.focusElement,
                },
            },
        },
        black: {
            color: theme.palette.primary.main,
        },
        grey: {
            color: theme.palette.colors.text.label,
        },
        lightblue: {
            color: theme.palette.colors.text.accent,
        },
    }),
);

export default UnderlineTextButton;
